module.exports = __webpack_public_path__ + "static/media/GTBSLong2w522@1x.a2002b19.webp";